import React, { Component } from 'react'

import ColorBar from 'components/Color-Bar'

class Hero extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {

  }

  render() {
    const heroImageUrl =  require(`../static/img/${this.props.image}`)

    const heroTitle = Array.isArray(this.props.title) ? this.props.title.map((copy, index) =>
      <React.Fragment key={`hero-title-${index}`}>{copy}</React.Fragment>
    ) : this.props.title

    const heroCopy = Array.isArray(this.props.copy) ? this.props.copy.map((copy, index) =>
      <React.Fragment key={`hero-copy-${index}`}>{copy}</React.Fragment>
    ) : this.props.copy
    return (
      <React.Fragment>
        <div className="container">
          <div className="hero-container">
            <div className="hero">
              <div className="hero__content">
                <h1 className="hero__title">{heroTitle}</h1>

                {this.props.copy && this.props.copy.length > 0 &&
                <p className="hero__copy">{heroCopy}</p>
                }

                <div className="arrow-down" />
              </div>

              <div className="hero__image parallax" style={{ backgroundImage: `url(${heroImageUrl})` }}></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Hero;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Hero.js